import { OfficeFieldWebInputType, OfficeFieldWebInputTypeEnum } from '@pages/office/models/office-data.model';
import { ISaveExcelFilterParam, ISaveExcelOrderByParam, SaveExcelOrderByParamAscending } from '@pages/office/models/save-excel-file.model';

import { ModalOptions } from 'ngx-bootstrap/modal';

export const GRID_CUSTOM_TEMPLATE_TYPES: OfficeFieldWebInputType[] = [OfficeFieldWebInputTypeEnum.web, OfficeFieldWebInputTypeEnum.email];

export const FIELD_NUMBER_TYPES: OfficeFieldWebInputType[] = [
  OfficeFieldWebInputTypeEnum.byte,
  OfficeFieldWebInputTypeEnum.short,
  OfficeFieldWebInputTypeEnum.int,
  OfficeFieldWebInputTypeEnum.double,
  OfficeFieldWebInputTypeEnum.long,
];

export const DEFAULT_PAGE_SETTING = {
  currentPage: '1',
  pageSize: '10',
};

export enum OfficeGridQueryParamsEnum {
  filter = 'filter',
  sortby = 'sortby',
}

export const filterEntries = (value: string): [string, string] => value.split(',') as [string, string];
export const getFilterList = (queryConfigFilter: Record<string, string>): ISaveExcelFilterParam[] => {
  return Object.entries(queryConfigFilter).map(([seq, searchText]) => ({ seq: Number(seq), searchText }));
};
export const getSortList = (queryConfigSort: string[]): ISaveExcelOrderByParam[] => {
  return queryConfigSort.map(sort => {
    const [seq, ascending] = filterEntries(sort);
    return { seq: Number(seq), ascending: Number(ascending) as SaveExcelOrderByParamAscending };
  });
};

export const getRelatedFromRecordsError = (relatedTab: string, relatedTitle: string): string =>
  relatedTab + ' records exist for the ' + relatedTitle + ' record and must be removed before deleting.';
export const getRelatedGridRecordsError = (relatedTitle: string): string =>
  'Related grid records exist for the ' + relatedTitle + ' record and must be removed before deleting';
export const getDetailRecordsError = (relatedTitle: string): string =>
  'Detail records exist for the ' + relatedTitle + ' record and must be removed before deleting';
export const getTabsWithErrorsError = (tabsWithErrors: string): string =>
  'Error occurred during detail records extraction for the ' + tabsWithErrors + ' record and must be removed manually before deleting';

export const DELETE_ROW_CONFIRMATION_POSITIVE = 'Yes';

export const DEFAULT_MODAL_OPTIONS: ModalOptions = {
  backdrop: 'static',
  ignoreBackdropClick: true,
  keyboard: true,
};

export const DETAILS_DELETE_INITIAL_STATE: ModalOptions['initialState'] = {
  modalData: {
    modalTitle: 'Delete Row',
    modalMessage: 'This record has related grid records that will also be deleted.  Are you sure?',
    modalAction: DELETE_ROW_CONFIRMATION_POSITIVE,
    closeButtonText: 'No',
    warningLevel: 'danger',
  },
};
export const DELETE_ROW_STATE: ModalOptions['initialState'] = {
  modalData: {
    modalTitle: 'Delete Row',
    modalMessage: 'Are you sure you want to delete this row?',
    modalAction: 'Delete',
    closeButtonText: 'Cancel',
    warningLevel: 'danger',
  },
};

export const getColumnType = (webInputType: OfficeFieldWebInputType): string => {
  switch (webInputType) {
    case OfficeFieldWebInputTypeEnum.int:
    case OfficeFieldWebInputTypeEnum.byte:
    case OfficeFieldWebInputTypeEnum.double:
    case OfficeFieldWebInputTypeEnum.short:
    case OfficeFieldWebInputTypeEnum.long:
      return 'number';
    case OfficeFieldWebInputTypeEnum.date:
    case OfficeFieldWebInputTypeEnum.month:
      return 'date';
    default:
      return 'string';
  }
};
